var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBluecheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_48116925ae3a82eb626852f6dfabe743",
    "data-name": "48116925ae3a82eb626852f6dfabe743",
    d: "M66,48A18,18,0,1,0,84,66,18,18,0,0,0,66,48ZM63.222,72.378a1.194,1.194,0,0,1-.762.381,1.248,1.248,0,0,1-.77-.389l-4.846-4.846,1.54-1.54,4.085,4.085,10.8-10.878,1.514,1.566Z",
    transform: "translate(-48 -48)",
    fill: "#16ebc3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluecheck);
export default __webpack_public_path__ + "static/media/bluecheck.a914b0150ce33ffb31b8b7b55466e86e.svg";
export { ForwardRef as ReactComponent };